import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";

Vue.use(Vuex);

export class RootState {
  page = 0;
}

export const pagelist = [
  "Einführung",
  "NeueVueApp",
  "Ordnerstruktur",
  "AppVue",
  "Router",
  "ViewsComponents",
  "Binding",
  "Dokumentation"
];

export default new Vuex.Store({
  state: {
    page: 0
  },
  mutations: {
    incr_page(state) {
      state.page += 1;
      router.push({ name: pagelist[state.page] });
    },
    decr_page(state) {
      state.page -= 1;
      router.push({ name: pagelist[state.page] });
    },
    synchronizeStore(state, routeName) {
      if (
        pagelist.find(el => {
          return routeName === el;
        })
      ) {
        state.page = pagelist.indexOf(routeName);
      }
    },
    setPage(state, pageIndex) {
      state.page = pageIndex;
      router.push({ name: pagelist[state.page] });
    }
  },
  actions: {},
  modules: {}
});
